import { Button, makeStyles, Typography, Box } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { basic, Values, oper as v_oper, member as v_member } from '../request/values';

import React, { Fragment, useState } from 'react';
import { COLORS } from '../shared/Theme';
import { useTranslation } from 'react-i18next';

import { useSnackbar } from 'notistack';
import ToastStr from '../request/toastStr';
import { TitleBackBar } from '../shared/header/TitleBar';
import DialogConfirm, { DialogInputText2 } from './Dialog';

const useStyles = makeStyles((theme) => ({
	box: {
		marginTop: '5vh',
	},
	button: {
		boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.16)',
		borderRadius: 24,
		width: '80vw',
		height: '6vh',
		marginBottom: '2.5vh',
		paddingLeft: '8vw',

		justifyContent: 'start',

		'& img': {
			marginRight: '4vw',
		},
		'& p': {
			color: `${COLORS.BROWNISH_GREY}`,
			fontSize: '4vw',
			fontFamily: 'NanumB',
			fontWeight: 'bold',
		},
		[theme.breakpoints.up('md')]: {
			width: '550px',
		},
	},
	buttonRow: {
		display: 'flex',
		width: '80vw',
		gap: '10px',
		marginBottom: '2.5vh',
		[theme.breakpoints.up('md')]: {
			width: '550px',
		},
	},
	halfButton: {
		boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.16)',
		borderRadius: 24,
		flex: 1,
		height: '15vh',
		'& .MuiButton-label': {
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			justifyContent: 'center',
			gap: '15px',
		},
		'& p': {
			color: `${COLORS.BROWNISH_GREY}`,
			fontFamily: 'NanumB',
			fontWeight: 'bold',
			fontSize: '4vw',
			wordBreak: 'keep-all',
		},
		[theme.breakpoints.up('md')]: {
			height: '140px',
			'& .MuiButton-label': {
				gap: '17px',
			},
			'& p': {
				fontSize: '0.8rem',
			},
		},
	},
	logoSection: {
		display: 'flex',
		flex: 1,
		width: '100%',
		alignItems: 'flex-end',
		paddingBottom: '5vh',
	},
	logo: {
		width: '5.5vw',
		maxWidth: '30px',
	},
	deleteAccountButton: {
		boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.16)',
		borderRadius: 24,
		marginBottom: '2.5vh',
		alignContent: 'left',
		'& img': {
			marginRight: '4vw',
		},
		'& p': {
			padding: '5px',
			color: `${COLORS.BROWNISH_GREY}`,
			fontSize: '9px',
			fontFamily: 'NanumB',
			fontWeight: 'bold',
		},
		[theme.breakpoints.up('md')]: {
			width: '30%',
			height: '4vh',
			'& p': {
				color: `${COLORS.BROWNISH_GREY}`,
				fontSize: '9px',
				fontFamily: 'NanumB',
				fontWeight: 'bold',
			},
		},
	},
	footer: {
		textAlign: 'center',
		marginLeft: 'auto',
		position: 'fixed',
		bottom: theme.spacing(3),
		boxSizing: 'border-box',
		left: '0',
		right: '0',
	},
	deleteWrapper: {
		textAlign: 'right',
		marginRight: '3vw',
		paddingBottom: '1vh',
		[theme.breakpoints.up('md')]: {
			marginRight: '0',
		},
	},
	classCodeBox: {
		width: '100%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		flexDirection: 'column',
		marginTop: '2vh',
	},
	classCodeBoxContent: {
		width: 'fit-content',
		backgroundColor: `${COLORS.WATER_BLUE}`,
		color: `${COLORS.WHITE}`,
		padding: '1vh 2vw',
		borderRadius: '10px',
	},
}));

const SERVER = basic.server;

const Setting: React.FC<any> = (props) => {
	const classes = useStyles();
	const { t } = useTranslation('common');
	let history = useHistory();

	const { member, setMember, deleteMember } = props;
	const { enqueueSnackbar, closeSnackbar } = useSnackbar();
	const [input, setInput] = useState<boolean>(false);
	const [logoutDialog, setLogoutDialog] = useState<boolean>(false);
	const [deleteAccountDialog, setDeleteAccountDialog] = useState<boolean>(false);
	const [classCreateDialog, setClassCreateDialog] = useState<boolean>(false);
	const [changeProgramDialog, setChangeProgramDialog] = useState<boolean>(false);
	const [changeTeamDialog, setChangeTeamDialog] = useState<boolean>(false);
	const [confirm, setConfirm] = useState<string>('');

	const handleClose = (key: string) => {
		if (key === 'input') setInput((prevState) => !prevState);
		else if (key === 'confirm') setConfirm((prevState) => '');
		else if (key === 'logout') {
			setLogoutDialog((prevState) => !prevState);
		} else if (key === 'deleteAccount') {
			setDeleteAccountDialog((prevState) => !prevState);
		} else if (key === 'classCreate') {
			setClassCreateDialog((prevState) => !prevState);
		} else if (key === 'changeProgram') {
			setChangeProgramDialog((prevState) => !prevState);
		} else if (key === 'changeTeam') {
			setChangeTeamDialog((prevState) => !prevState);
		}
	};

	const handleInputOpen = () => {
		setInput(true);
	};

	const handleLogoutOpen = () => {
		setLogoutDialog(true);
	};

	const handleClassCreateOpen = () => {
		setClassCreateDialog(true);
	};

	const handleDeleteMemberOpen = () => {
		setDeleteAccountDialog(true);
	};

	const handleChangeProgramOpen = () => {
		setChangeProgramDialog(true);
	};

	const handleChangeTeamOpen = () => {
		setChangeTeamDialog(true);
	};

	const handleClassCreate = () => {
		postDeleteOperClass();
	};

	const handleConfirmOpen = (classCode: string) => {
		if (classCode !== '') {
			setConfirm(classCode);
			setInput(false);
		}
	};

	const handleChangeProgram = () => {
		window.location.href = 'https://educator.youstarter.co.kr/educator/select';
	};

	const postChangeTeam = () => {
		axios({
			method: 'POST',
			withCredentials: true,
			url: SERVER + v_member.member + v_member.company_exit,
			data: {
				email: member.id,
				companyNum: member.companyNum,
			},
		})
			.then((res) => res.data)
			.then((data: any) => {
				if (data.code == Values.SUCCESS_CODE) {
					setMember(
						Object.assign({}, member, {
							companyNum: 0,
							companyType: null,
						}),
					);
					history.push({
						pathname: '/CompanyProcess',
					});
				} else if (data.code == Values.COMPANY_MEMBER_REMAIN_CODE) {
					enqueueSnackbar(ToastStr.COMPANY_MEMBER_REMAIN_STR, {
						variant: 'warning',
					});
				} else {
					enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, {
						variant: 'error',
					});
				}
				handleClose('changeTeam');
			})
			.catch(() => {
				enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, {
					variant: 'error',
				});
				handleClose('changeTeam');
			});
	};

	const logout = () => {
		if (member.type === 'oper') {
			deleteMember();
			window.location.href = 'https://educator.youstarter.co.kr/educator/login?logout=true';
		} else {
			if (member.type === 'admin') {
				deleteMember();
			} else if (member.type === 'member') {
				setMember(Object.assign({}, { id: member.id }));
			}
			history.push('/');
		}
	};

	const goDeleteAccount = () => {
		history.push('/deleteUserAccount');
	};

	const postDeleteOperClass = () => {
		axios({
			method: 'POST',
			withCredentials: true,
			url: SERVER + v_oper.oper + v_oper.delete_class,
			data: {
				operId: member.id,
			},
		})
			.then((res) => {
				let member = localStorage.getItem('member');
				if (member) {
					const memberData = JSON.parse(member);
					memberData.classCode = '';
					memberData.classVersion = '';
					setMember(Object.assign(memberData));
				}
				history.push({
					pathname: '/operation/createClass',
				});
			})
			.catch(() => {
				console.log('delete class fail');
			});
	};

	const postChangeClass = () => {
		let url;
		let data;
		if (member.type === 'member') {
			setMember(Object.assign({}, { id: member.id }));
			history.push('/ClassEnter?classCode=' + confirm);
			return;
		} else if (member.type === 'oper') {
			url = SERVER + v_oper.oper + v_oper.class_enter;
			data = {
				classCode: confirm,
				email: member.id,
			};
			axios({
				method: 'POST',
				data: data,
				withCredentials: true,
				url: url,
			})
				.then((res) => res.data)
				.then((data: any) => {
					if (data.code == Values.SUCCESS_CODE) {
						if (member.type === 'member') {
							setMember(
								Object.assign({}, member, {
									companyNum: 0,
									classCode: confirm,
									classVersion: data.class_version,
								}),
							);
						} else if (member.type === 'oper') {
							setMember(
								Object.assign({}, member, {
									classCode: confirm,
									classVersion: data.class_version,
								}),
							);
						}

						history.push('/');
					} else if (data.code == Values.CLASS_NO_START_CODE) {
						enqueueSnackbar(ToastStr.CLASS_NO_START_STR, {
							variant: 'warning',
						});
					} else if (data.code == Values.CLASS_FINISH_CODE) {
						enqueueSnackbar(ToastStr.CLASS_ALREADY_END_STR, {
							variant: 'warning',
						});
					} else if (data.code == Values.FAIL_CODE) {
						enqueueSnackbar(ToastStr.CLASS_ENTER_FAIL, {
							variant: 'warning',
						});
					} else {
						enqueueSnackbar(ToastStr.CLASS_ENTER_FAIL, {
							variant: 'error',
						});
					}
					handleClose('confirm');
				});
		}
	};

	return (
		<div>
			<TitleBackBar history={history} title={t('Setting.pageTitle')} titleIcon="setting" />

			<div className={classes.classCodeBox}>
				<div className={classes.classCodeBoxContent}>
					<Typography style={{ fontSize: '1rem', fontWeight: 'bold' }}>
						{t('Setting.classCodePrefix')} {member.classCode}
					</Typography>
				</div>
			</div>

			<Box className={classes.box} display="grid" justifyContent="center" alignItems="center">
				{member.type === 'oper' ? (
					<>
						<div className={classes.buttonRow}>
							<Button onClick={() => handleInputOpen()} className={classes.halfButton}>
								<img src="/images/edit.png" style={{ width: '1.5rem' }} />
								<Typography style={{ fontSize: '0.8rem' }}>{t('Setting.changeClassCode')}</Typography>
							</Button>
							{member.language === 'ko' && (
								<Button onClick={() => handleClassCreateOpen()} className={classes.halfButton}>
									<img src="/images/add.png" style={{ width: '1.5rem' }} />
									<Typography style={{ fontSize: '0.8rem' }}>{t('Setting.createClassCode')}</Typography>
								</Button>
							)}
						</div>
						{member.language === 'ko' && (
							<Button onClick={() => handleChangeProgramOpen()} className={classes.button}>
								<img src="/images/change.webp" style={{ width: '1.7rem' }} />
								<Typography style={{ fontSize: '0.8rem' }}>{t('Setting.changeProgram')}</Typography>
							</Button>
						)}
					</>
				) : (
					<>
						<Button onClick={() => handleInputOpen()} className={classes.button}>
							<img src="/images/edit.png" style={{ width: '1.7rem' }} />
							<Typography style={{ fontSize: '0.8rem' }}>{t('Setting.changeClassCode')}</Typography>
						</Button>
						<Button onClick={() => handleChangeTeamOpen()} className={classes.button}>
							<img src="/images/change.webp" style={{ width: '1.7rem' }} />
							<Typography style={{ fontSize: '0.8rem' }}>{t('Setting.changeTeam')}</Typography>
						</Button>
					</>
				)}

				<Button onClick={() => handleLogoutOpen()} className={classes.button}>
					<img src="/images/logout.webp" style={{ width: '1.7rem' }} />
					<Typography style={{ fontSize: '0.8rem' }}>{t('Setting.logout')}</Typography>
				</Button>
			</Box>

			<div className={classes.logoSection}>
				<div style={{ flexDirection: 'column', width: '100vw' }}>
					<div className={classes.deleteWrapper}>
						<Button onClick={() => handleDeleteMemberOpen()} className={classes.deleteAccountButton}>
							<Typography>{t('Setting.deleteAccount')}</Typography>
						</Button>
					</div>
					<div className={classes.footer}>
						<img className={classes.logo} src="/images/p.webp" />
					</div>
				</div>
			</div>

			<DialogInputText2
				open={input}
				inputType={'text'}
				handleClose={() => handleClose('input')}
				title={t('Setting.inputChangeClassCodeTitle')}
				yesConfirm={(e: any, classCode: string) => handleConfirmOpen(classCode)}
				noConfirm={() => handleClose('input')}
			/>
			<DialogConfirm
				open={classCreateDialog}
				handleClose={() => handleClose('classCreate')}
				title={t('Setting.createClassDialogTitle')}
				context={t('Setting.createClassDialogContext')}
				yesText={t('common.yesText')}
				noText={t('common.noText')}
				yesConfirm={() => handleClassCreate()}
				noConfirm={() => handleClose('classCreate')}
			/>
			<DialogConfirm
				open={confirm === '' ? false : true}
				handleClose={() => handleClose('confirm')}
				title={t('Setting.checkEditClassCodeTitle')}
				context={confirm}
				yesConfirm={() => postChangeClass()}
				noConfirm={() => handleClose('confirm')}
			/>
			<DialogConfirm
				open={changeProgramDialog}
				handleClose={() => handleClose('changeProgram')}
				title={t('Setting.ChangeProgramDialogTitle')}
				context={t('Setting.ChangeProgramDialogContext')}
				yesText={t('common.yesText')}
				noText={t('common.noText')}
				yesConfirm={() => handleChangeProgram()}
				noConfirm={() => handleClose('changeProgram')}
			/>
			<DialogConfirm
				open={changeTeamDialog}
				handleClose={() => handleClose('changeTeam')}
				title={t('Setting.changeTeamDialogTitle')}
				context={t('Setting.changeTeamDialogContext')}
				yesText={t('common.yesText')}
				noText={t('common.noText')}
				yesConfirm={() => postChangeTeam()}
				noConfirm={() => handleClose('changeTeam')}
			/>
			<DialogConfirm
				open={logoutDialog}
				handleClose={() => handleClose('logout')}
				title={t('Setting.pageTitle')}
				context={t('Setting.logoutConfirmTitle')}
				yesText={t('common.yesText')}
				noText={t('common.noText')}
				yesConfirm={() => logout()}
				noConfirm={() => handleClose('logout')}
			/>
			<DialogConfirm
				open={deleteAccountDialog}
				handleClose={() => handleClose('deleteAccount')}
				title={t('Setting.deleteAccount')}
				context={t('Setting.goDeleteAccountTitle')}
				yesText={t('common.yesText')}
				noText={t('common.noText')}
				yesConfirm={() => goDeleteAccount()}
				noConfirm={() => handleClose('deleteAccount')}
			/>
		</div>
	);
};

export default Setting;
